<template class="full-height">
  <div class="dialogComponents-container">
    <div>
      <el-dialog
        class="dialog-dialog"
        @closed="setDialog(false)"
        title="系統通知"
        :visible.sync="innerDialogVisible"
        append-to-body
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :show-close="false"
        :width="device == 'mobile' ? '90%' : '60%'"
      >
        <div>
          <el-alert
            style="background-color: #ffd643; color: #4b4b4b"
            :title="content"
            type="info"
            effect="dark"
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button type="danger" @click="setDialog(false)">關 閉</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DialogComponents',
  props: {
    content: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['showDialog', 'device']),
  },
  components: {},
  watch: {
    showDialog() {
      this.innerDialogVisible = this.showDialog
    },
  },
  data() {
    return {
      innerDialogVisible: false,
    }
  },
  async created() {},
  methods: {
    setDialog(doing) {
      this.$store.dispatch('app/showDialog', doing)
    },
  },
}
</script>

<style>
.dialog-dialog .el-dialog__body {
  user-select: auto !important;
  border-radius: 14px !important;
  font-size: 20px !important;
  padding: 15px;
}

.dialog-dialog .el-alert__title {
  font-size: 20px !important;
}
</style>
